






import Vue from 'vue';
import radioBlank from 'vue-material-design-icons/RadioboxBlank.vue';
import radioMarked from 'vue-material-design-icons/RadioboxMarked.vue';
import toggleOn from 'vue-material-design-icons/ToggleSwitch.vue';
import squareEditOutline from 'vue-material-design-icons/SquareEditOutline.vue';
import arrowRight from 'vue-material-design-icons/ArrowRight.vue';
import close from 'vue-material-design-icons/Close.vue';
import plus from 'vue-material-design-icons/Plus.vue';
import trashCanOutline from 'vue-material-design-icons/TrashCanOutline.vue';

const icons: { [name: string]: Vue.Component } = {
  radioBlank,
  radioMarked,
  toggleOn,
  squareEditOutline,
  arrowRight,
  close,
  plus,
  trashCanOutline
};

interface Data {
  icon: Vue.Component;
}

export default Vue.extend({
  props: {
    name: { 
      type: String,
      required: true,
      validator: (iconName: string) => Object.keys(icons).includes(iconName),
    },
    size: { type: Number, default: 24 },
    color: { type: String, default: 'currentColor' }
  },
  data(): Data {
    return { icon: icons[this.name] };
  },
});
